module.exports = __webpack_public_path__ + "static/media/22.02eb31f3.jpg";